import React from 'react';

const FacebookIconX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.818359" y="0.242188" width="35.375" height="35.2578" rx="17.6289" fill="#069169" />
    <path
      d="M28.1934 17.9297C28.1934 12.5781 23.8574 8.24219 18.5059 8.24219C13.1543 8.24219 8.81836 12.5781 8.81836 17.9297C8.81836 22.7648 12.3609 26.7727 16.9922 27.5V20.7301H14.5312V17.9297H16.9922V15.7953C16.9922 13.3676 18.4375 12.0266 20.6512 12.0266C21.7113 12.0266 22.8199 12.2156 22.8199 12.2156V14.5984H21.598C20.3949 14.5984 20.0195 15.3453 20.0195 16.1113V17.9297H22.7063L22.2766 20.7301H20.0195V27.5C24.6508 26.7727 28.1934 22.7648 28.1934 17.9297Z"
      fill="white"
    />
  </svg>
);

export default FacebookIconX;
